import Vue from 'vue'
import App from './App.vue'
import vantPlugin from './plugins/vant.plugin';
import hmPlugin from './plugins/hm.plugin';
import components from './components'
import router from './router/index'
import constants from './constants';
import store from './store';
import api from './api'
import 'vant/lib/index.css';
import './assets/css/common.less'
import Cookies from 'js-cookie';
import device, { isIOS, isWechatDevTools } from '@/utils/device';
import Toast from 'vant/lib/toast';
import { initial } from 'lodash';
import Storage from '@/utils/storage'
import filters from './utils/filters'
import '@vant/touch-emulator';
import './utils/rem'
import loadCaptchaPlugin from './plugins/captcha';
import { mapInit } from './utils/map';
import { setSceneStr } from './utils/common';

Vue.use(vantPlugin)
Vue.prototype.$const = constants;
Vue.prototype.$api = api
Object.keys(components).forEach(key => {
  Vue.component(key, components[key]);
});
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})

export let routerStack = [];
export async function getWxConfig(signUrl) {
  try {
    const res = await api.getSign({ url: encodeURIComponent(signUrl) });
    wx.config({
      debug: false,
      ...res,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'updateAppMessageShareData',
        'updateTimelineShareData',
        'getLocation',
        'openLocation',
      ],
    });
    wx.ready(() => {
      console.log('微信 jssdk 初始化成功');
    });
    wx.error(err => {
      throw new Error('微信 jssdk 初始化失败' + err.errMsg);
    });
  } catch (err) {
    Toast(err.message);
  }
}
const initApp = async () => {
  try {
    await Promise.all([store.dispatch('getDict'), store.dispatch('getUserInfo'), store.dispatch('setCaptchaConfig')])
  } catch (err) {
    // console.log(err)
  }
  const webConfig = await store.dispatch('getWebConfig')
  if (webConfig.baidu_tongji) {
    Vue.use(hmPlugin, { id: webConfig.baidu_tongji });
  }
  if (webConfig.captcha === 2) {
    Vue.use(loadCaptchaPlugin);
  }

  await mapInit(webConfig);

  router.beforeEach((to, from, next) => {
    routerStack.push(to)
    // 百度统计页面跟踪
    if (process.env.NODE_ENV === 'production') {
      window._hmt && window._hmt.push(['_trackPageview', to.fullPath]);
    }

    const userType = Storage.get('user_type')
    const token = sessionStorage.getItem('token') || Cookies.get('token') || Storage.get('token');
    const isCompany = Boolean(token && Number(userType) === 2)

    if (isCompany && !webConfig.odd_jobs_is_talent && (to.name === 'projectManage' || to.name === 'oddPublish')) {
      if (to.name === 'oddPublish') {
        window.location.href = `${window.location.protocol}//${webConfig.url}/seekwap/recruit/publish?token=${token}`;
        return
      }
      window.location.href = `${window.location.protocol}//${webConfig.url}/seekwap?token=${token}`;
      return
    } else if (webConfig.odd_jobs_application) {
      if (to.name === 'error') {
        next({ path: '/' });
      } else if (to.meta.needLogin && !token && to.name !== 'login') {
        next({ path: '/login' });
      } else if (to.meta.userType && !to.meta.userType.includes(Number(userType))) {
        next({ path: '/' });
      } else {
        const { callback_data, scene_str } = to.query;
        // 路由拦截
        // 场景码跟踪 发现场景码则存储后重定向
        if (scene_str) {
          setSceneStr(scene_str);
          next();
        } else if (callback_data) {
          // 获取 openid 重定向，重新设置 window.entryUrl
          if (isIOS) {
            window.entryUrl = `${location.origin}/odd${to.fullPath}`;
            console.log('授权重定向，重新设置entryUrl' + window.entryUrl);
          }

          const callbackData = JSON.parse(decodeURIComponent(callback_data));

          const { token, action, openid, unionid, status, imUserId, sig, platform } = callbackData;
          // 如果有openid，就存储到localStorage中，避免后续重复获取
          openid && localStorage.setItem('PAY_OPENID', openid);
          console.log(openid, 'openid')
          switch (action) {
            // 其他逻辑没有迁移

            default: {
              const { callback_data, ...query } = to.query;
              const newQuery = {
                ...query,
                ...callbackData,
              };
              console.log('{ path: to.path, query: newQuery, params: to.params }', { path: to.path, query: newQuery, params: to.params })
              next({ path: to.path, query: newQuery, params: to.params });
              break;
            }
          }
        } else {
          next();
        }
      }
    } else if (to.name !== 'error') {
      next({ path: '/error' });
    } else {
      next()
    }

  })

  router.afterEach((to, from) => {
    if (!device.isWechat) {
      return;
    }
    setTimeout(()=>{
      // ios设备微信内访问页面，url不会变化，一直是entryUrl
      // 需要记录首次进入的url，用于微信sdk的签名
      if (isWechatDevTools) {
        window.entryUrl = window.location.href;
      } else if (isIOS) {
        if (!window.entryUrl) {
          window.entryUrl = window.location.href;
        }
      } else {
        window.entryUrl = window.location.href;
      }
      getWxConfig(window.entryUrl);
    }, 0)
  });

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}
initApp()
